import React from 'react';
import PropTypes from 'prop-types';
import RangeCalendar from './RangeCalendar';
import { addMonths } from 'material-ui/DatePicker/dateUtils';

import styles from './styles/DateRangeSelector';
import injectSheet from 'react-jss';

class DateRangeSelector extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleTouchTapDay = this.handleTouchTapDay.bind(this);
        this.getMonth = this.getMonth.bind(this);
    }

    handleTouchTapDay(event, date) {
        // Todo
        if (typeof this.props.onTouchTap === 'function') {
            this.props.onTouchTap(date);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.rangeStart !== this.props.rangeStart || prevProps.rangeEnd !== this.props.rangeEnd) {
            this.setState({
                rangeStart: this.props.rangeStart,
                rangeEnd: this.props.rangeEnd,
            });
        }
    }

    getMonth(index) {
        const date = addMonths(this.props.firstMonthDay, index);

        if (date.getMonth() !== index) {
            date.setTime(date.getTime() - (date.getDate() * 24 * 60 * 60 * 1000));
        }

        return date;
    }

    render() {
        const classes = this.props.sheet.classes;

        return (
            <div className={ classes.container }>
                {
                    Array(this.props.noOfCalendars).fill('')
                        .map((v, i) => {
                            return <div key={ `RangeCalendar_${ classes.flexContainer + i }` } className={ classes.flexContainer }>
                                <RangeCalendar
                                    DateTimeFormat={ this.props.DateTimeFormat }
                                    firstDayOfWeek={ this.props.firstDayOfWeek }
                                    leftmost={ i === 0 }
                                    locale={ this.props.locale }
                                    maxDate={ this.props.maxDate }
                                    minDate={ this.props.minDate }
                                    month={ this.getMonth(i) }
                                    nextMonthHandler={ this.props.nextMonthButtonClicked }
                                    onTouchTapDay={ this.handleTouchTapDay }
                                    prevMonthHandler={ this.props.prevMonthButtonClicked }
                                    rangeEnd={ this.props.rangeEnd }
                                    rangeStart={ this.props.rangeStart }
                                    rightmost={ i === (this.props.noOfCalendars - 1) }
                                    shouldDisableDate={ this.props.shouldDisableDate }
                                />
                            </div>;
                        })
                }
            </div>
        );
    }
}
DateRangeSelector.defaultProps = {
    firstDayOfWeek: 1,
};
DateRangeSelector.propTypes = {
    DateTimeFormat: PropTypes.func.isRequired,
    firstDayOfWeek: PropTypes.number,
    firstMonthDay: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    nextMonthButtonClicked: PropTypes.func.isRequired,
    noOfCalendars: PropTypes.number,
    onTouchTap: PropTypes.func,
    prevMonthButtonClicked: PropTypes.func.isRequired,
    rangeEnd: PropTypes.object,
    rangeStart: PropTypes.object,
    sheet: PropTypes.object,
    shouldDisableDate: PropTypes.func,
};

const component4Export = injectSheet(styles)(DateRangeSelector);

export default component4Export;



// WEBPACK FOOTER //
// ./src/components/input/DateRange/DateRangeSelector.js